import { Injectable } from '@angular/core';
import { VideoSession } from '../../models/app/video-session';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class VideoSessionStore extends BaseStore<VideoSession | null> {}
